import { post } from "../../api";
import url from "../../api/apisList";
import * as types from "./actionTypes";

// export const saveUserDataAction = (userCredentials) => {
//   let apiUrl = url("login");

//   return async (dispatch) => {
//     try {
//       const res = await post(apiUrl, userCredentials);
//       let user;

//       if (res?.data) {
//         user = res?.data?.user;
//       }

//       dispatch({
//         type: types.SAVE_USER_ACTION,
//         payload: user,
//       });
//     } catch (err) {
//       dispatch({
//         type: types.SAVE_USER_ACTION_FAIL,
//         payload: err,
//       });
//     }
//   };
// };

export const userLogout = (userdetails) => {
  let apiUrl = url("logout");

  return async (dispatch) => {
    try {
      const res = await post(apiUrl, userdetails);
      dispatch({
        type: types.USER_LOGOUT,
      });
      sessionStorage.clear();
    } catch (err) {
      dispatch({
        type: types.USER_LOGOUT_FAIL,
        payload: err,
      });
    }
  };
};

export const userUpdateDetails = (userdetails) => {
  return async (dispatch) => {
    dispatch({
      type: types.SETTINGS_USER_UPDATED,
      payload: userdetails,
    });
  };
};

export const CandidateLoginAction = (userCredentials) => {
  let apiUrl = url("candidate_login");

  return async (dispatch) => {
    try {
      const res = await post(apiUrl, userCredentials);
      let user;
      if (res?.data) {
        user = res?.data?.user;
      }
      dispatch({
        type: types.CANDIDATE_LOGIN_ACTION,
        payload: user,
      });

      return res?.data;
    } catch (err) {
      dispatch({
        type: types.CANDIDATE_LOGIN_ACTION_FAIL,
        payload: err,
      });
      return "login_failed";
    }
  };
};

export const saveUserDataAction = (userCredentials, userRole) => {
  const apiUrl = url("login");
  return async (dispatch) => {
    try {
      const res = await post(apiUrl, userCredentials);
      let user;
      if (res?.data) {
        user = res?.data?.user;
      }
      dispatch({
        type: types.SAVE_USER_ACTION,
        payload: user,
      });

      return res?.data;
    } catch (err) {
      dispatch({
        type: types.SAVE_USER_ACTION_FAIL,
        payload: err,
      });
      return "login_failed";
    }
  };
};

export const userActivity = (user) => {
  let apiUrl = url("get_user_last_seen");

  return async (dispatch) => {
    try {
      const data = {
        user_id: user.id,
      };
      let activity;
      const res = await post(apiUrl, data);

      if (res?.data) {
        activity =
          res?.data && res?.data.length > 0 && res?.data?.[0]?.is_active === 1
            ? true
            : false;
      }
      dispatch({
        type: types.USER_ACTIVITY_ACTION,
        payload: activity,
      });

      sessionStorage.clear();
    } catch (err) {
      dispatch({
        type: types.USER_ACTIVITY_ACTION_FAIL,
        payload: err,
      });
    }
  };
};
